export const lastClickTime = localStorage.getItem('lastSurveyStartButtonClick');
